import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getSlateTypographyFontSize } from "@faire/retailer-shared/SlateMappings/getSlateTypographyFontSize";
import { SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { numberToPixel } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/conversions";
import * as styles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/ImageOrIcon/styles/SDUIImageOrIconRendererStyles.css";
import { getSlateIcon } from "@faire/web--source/slate/SlateMappings/getSlateIcon";
import { Sizing } from "@faire/web-api--source/indigofair/data/Sizing";
import { TextStyleType } from "@faire/web-api--source/indigofair/data/TextStyleType";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";
var _obj;
var SIZE_MAP = (_obj = {}, _define_property(_obj, Sizing.SIZING_UNKNOWN, undefined), _define_property(_obj, Sizing.SIZING_S, 16), _define_property(_obj, Sizing.SIZING_M, 24), _define_property(_obj, Sizing.SIZING_L, 32), _obj);
export var SDUIImageOrIconRenderer = function(param) {
    var dataTestId = param.dataTestId, className = param.className, imageOrIcon = param.imageOrIcon, parentColorToken = param.parentColorToken, parentFontStyle = param.parentFontStyle, componentStyle = param.componentStyle;
    if (imageOrIcon.image) {
        var height = imageOrIcon.image_or_icon_size ? SIZE_MAP[imageOrIcon.image_or_icon_size] : imageOrIcon.image.height;
        var width = imageOrIcon.image_or_icon_size ? SIZE_MAP[imageOrIcon.image_or_icon_size] : imageOrIcon.image.width;
        var _obj;
        return /*#__PURE__*/ _jsx("div", {
            "data-test-id": dataTestId,
            className: classNames(className, styles.imgStyle),
            style: _object_spread({}, assignInlineVars((_obj = {}, _define_property(_obj, styles.height, numberToPixel(height)), _define_property(_obj, styles.width, numberToPixel(width)), _obj)), componentStyle),
            children: /*#__PURE__*/ _jsx(SDUIImage, {
                altText: imageOrIcon.image.alt_text,
                responsiveImage: {
                    mobileAndAbove: imageOrIcon.image
                },
                optimizeImageOptions: {
                    mobileAndAbove: {
                        height: height,
                        width: width
                    }
                }
            })
        });
    }
    if (imageOrIcon.icon) {
        var SlateIcon = getSlateIcon(imageOrIcon.icon);
        var _imageOrIcon_image_or_icon_size;
        var iconSizeString = (_imageOrIcon_image_or_icon_size = imageOrIcon.image_or_icon_size) !== null && _imageOrIcon_image_or_icon_size !== void 0 ? _imageOrIcon_image_or_icon_size : imageOrIcon.icon.icon_size;
        // if icon size is not provided, default to the parent font size otherwise default to the icon size
        var iconSize = iconSizeString ? SIZE_MAP[iconSizeString] + "px" : getSlateTypographyFontSize(parentFontStyle !== null && parentFontStyle !== void 0 ? parentFontStyle : TextStyleType.TEXT_STYLE_TYPE_UNKNOWN);
        var _imageOrIcon_icon_color_token;
        return /*#__PURE__*/ _jsx(SlateIcon, {
            "data-test-id": dataTestId,
            fontSize: iconSize,
            height: iconSize,
            width: iconSize,
            className: className,
            style: componentStyle,
            color: getSlateColorToken((_imageOrIcon_icon_color_token = imageOrIcon.icon.color_token) !== null && _imageOrIcon_icon_color_token !== void 0 ? _imageOrIcon_icon_color_token : parentColorToken)
        });
    }
    return null;
};
